import React, { useRef, useState, useEffect } from 'react';
import './RowMarquee.scss';

/**
 * @param {Array} icons - liste d'icônes {path, name}
 * @param {string} direction - 'left' ou 'right'
 * @param {number} duration - durée (en secondes) du défilement complet
 * @param {boolean} centerNoScroll - si true, on centre les icônes quand pas de défilement, sinon on les aligne à gauche
 */
export default function RowMarquee({ icons = [], direction = 'left', duration = 30, centerNoScroll = true }) {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);

  useEffect(() => {
    if (!containerRef.current || !contentRef.current) return;
    const containerWidth = containerRef.current.offsetWidth;
    const contentWidth = contentRef.current.scrollWidth;
    setShouldScroll(contentWidth > containerWidth);
  }, [icons]);

  // On duplique le tableau d'icônes UNIQUEMENT si le scroll est nécessaire
  const iconsToDisplay = shouldScroll ? [...icons, ...icons] : icons;

  // Détermine la classe CSS selon direction & shouldScroll
  let scrollClass = 'no-scroll';
  if (shouldScroll) {
    scrollClass = direction === 'left' ? 'scroll-left' : 'scroll-right';
  } else if (centerNoScroll) {
    scrollClass = 'no-scroll-center';
  }

  return (
    <div className="row-marquee-container" ref={containerRef}>
      <div
        className={`row-marquee-inner ${scrollClass}`}
        ref={contentRef}
        style={shouldScroll ? { animationDuration: `${duration}s` } : {}}
      >
        {iconsToDisplay.map((icon, index) => (
          <div className="icon-box" key={`${icon.path}-${index}`}>
            <img src={icon.path} alt={icon.name} className="icon-img" />
          </div>
        ))}
      </div>
    </div>
  );
}
